export interface Ad {
  title: string;
  description: string;
  buttonText: string;
  siteUrl: string;
  playingTime: string;
  imageUrl?: string;
  videoUrl?: string;
}
